'use strict';

import { MachineLearning } from "aws-sdk";

/* jshint -W098 */
angular.module('mean.accounts-receivable').controller('BillingInvoiceController', ['$scope', '$rootScope', '$location', 'Global', 'MeanUser', 'toaster', '$filter', 'Customers', 'Charts', 'contractEstimateService', 'TradeDrawService', 'tradeCodeService', 'Projects', 'ngDialog', 'Estimates', 'TradeInvoices', 'Trades', 'aceUtils', 'ProjectTasks', 'userService',
  function($scope, $rootScope, $location, Global, MeanUser, toaster, $filter, Customers, Charts, contractEstimateService, TradeDrawService, tradeCodeService, Projects, ngDialog, Estimates, TradeInvoices, Trades, aceUtils, ProjectTasks, userService) {
    var vm = this;

    vm.selectedNode = null;
    vm.pageState = 'companyInfo';
    vm.project_invoices = null;
    vm.draw_items = [];
    vm.currentlySelectedNode = null;

    console.log('BillingInvoiceController');

    $scope.sortType = ['description', 'lot', 'plan', 'contract'];
    $scope.sortReverse = false;

    vm.user = MeanUser.user;
    vm.trade_code = tradeCodeService.getCode(vm.user.trade[0]);
    vm.trade_draw_data = [];
    vm.invoiceDate = moment();

    vm.items = [];
    vm.inputText = '';
    vm.minlength = 1;
    vm.selected = {};

    vm.payment = {
        amount: 0,
        from: '',
        date: null,
        reference: ''
    }

    vm.depositAccounts = [];
    $scope.mainAccountID = null;
    vm.company_emails = $scope.getCompanyEmails();
    $scope.user = MeanUser.user;

    Trades.query({'trade': vm.user.trade[0], 'company_code': vm.user.contractor_code}, function(trades) {
        if(trades.length !== 1) {
            toaster.pop('error', 'Trade Info Error', 'Problem getting trade information.');
        } else {
            vm.trade = {
                'name': trades[0].name,
                'address_one': trades[0].address_one,
                'address_two': trades[0].city + ', ' + trades[0].state + ' ' + trades[0].zip,
            }
            $scope.mainAccountID = trades[0].main_account_id._id;
            Array.isArray(trades[0].company_emails) && (vm.company_emails =  trades[0].company_emails);
            $scope.getAllCustomers($scope.mainAccountID);
            $scope.getDepositAccount($scope.mainAccountID);
        }
    });

    $scope.getDepositAccount = function (main_accountId) {
        var currentCharQuery = {
            type: 'TRAN_ACCOUNT',
            isDeleted: false,
            status: 'Active',
            userId: main_accountId,
            parentOfAccountType : 'Current Assets'
        }

        // Get current Account
        Charts.query(currentCharQuery, function (accounts) {
            if (accounts.length) {
                vm.depositAccounts = accounts;
            }
        });
    }

    $scope.getAllCustomers = function (mainACID) {
        vm.items = [];
        Customers.query({ 'isDeleted': false, 'userId': mainACID }, function (customers) {
            if(customers.length) {
                _.each(customers, function(customer, indexNo) {
                    vm.items.push({ index: indexNo + 1, id: indexNo.toString(), label: customer.name });
                });
            }
        });
    }
    
    $rootScope.$on("BillingDataRowSelected", function(e, args) {
        vm.selectedNode = args

        vm.selectedNode.trade_name = vm.trade.name;
        vm.selectedNode.trade_address_one = vm.trade.address_one;
        vm.selectedNode.trade_address_two = vm.trade.address_two;

        if(vm.selectedNode !== vm.currentlySelectedNode)
            vm.newRowSelection();
    });

    vm.newRowSelection = function() {
        if(vm.selectedNode === vm.currentlySelectedNode) {
            return;
        } else {
            vm.currentlySelectedNode = vm.selectedNode;
        }

        vm.pageState = 'companyInfo';
        console.log(vm);
        var proj_num = 0;
        if(vm.project) {
            proj_num = vm.project.job_code;
            vm.project_extras = $scope.getProjectExtras(vm.project._id);
        }

        vm.current_invoice_total = 0;
        vm.invoice_items = [];

        if(vm.selectedNode.type === 'builder') {
            vm.project_invoices = $scope.getAllInvoices();
            // vm.trade_options = TradeDrawService.getProjectOptions(
            //     vm.selectedNode.trade_code, vm.selectedNode.company_code, vm.selectedNode.job_code);

            // vm.project_settings = TradeDrawService.getProjectSettings(
            //     vm.selectedNode.trade_code, vm.selectedNode.company_code, vm.selectedNode.job_code);
            vm.selectedNode.invoice_data = [];
            vm.selectedNode.payment_data = [];
            _.each(vm.project_invoices, function(project) {
                _.each(project.invoices, function(invoice) {
                    if(!invoice.code) {
                        var type = 'C';
                        if(invoice.type === 'option') {
                            type = 'OP';
                        } else if (invoice.type === 'extra') {
                            type = 'E';
                        }
                        invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                        '-' + aceUtils.padDigits(invoice.number, 2);
                    }
                    vm.selectedNode.invoice_data.push(invoice);

                    _.each(invoice.payments, function(payment) {
                        if(payment.from == vm.selectedNode.builder_name) {
                            vm.selectedNode.payment_data.push({
                                from: payment.from,
                                reference: payment.reference,
                                date: payment.date,
                                type: invoice.type,
                                code: invoice.code,
                                amount: invoice.amount - invoice.paid, //amount is amount open after deducting amount paid
                                paid: payment.amount,
                            });
                        }
                    });
                });
            })

        } else {
            vm.project_invoices = $scope.getProjectInvoices(vm.selectedNode.job_code);
            vm.trade_options = TradeDrawService.getProjectOptions(
                vm.selectedNode.trade_code, vm.selectedNode.company_code, vm.selectedNode.job_code);

            vm.project_settings = TradeDrawService.getProjectSettings(
                vm.selectedNode.trade_code, vm.selectedNode.company_code, vm.selectedNode.job_code);
            
            if((vm.selectedNode.type === 'project' || vm.selectedNode.type === 'phase') &&
                proj_num !== vm.selectedNode.job_code) {

                Projects.query({'type': 'getProjectForJobCode', 
                    'company_code': vm.selectedNode.company_code, 
                    'trade_code': vm.selectedNode.trade_code, 
                    'job_code': vm.selectedNode.job_code}, function(ret_data) {
                    vm.project = ret_data[0];

                    vm.draw_items = $filter('unique')(vm.trade_draw_data, 'number');

                    if(!vm.project.name) {
                        vm.project.name = 'Not Set';
                    }
                    if(!vm.project.contact.phone) {
                        vm.project.contact.phone = 'Not Set';
                    }
                    if(!vm.project.contact.address_one) {
                        vm.project.contact.address_one = 'Not Set';
                    }
                });
            }

            if(vm.selectedNode.type === 'project' || vm.selectedNode.type === 'phase') {
                vm.trade_draw_data = TradeDrawService.getProjectDraws(vm.selectedNode.builder_name,
                    vm.selectedNode.trade_code, vm.selectedNode.company_code, vm.selectedNode.job_code);

                //set the list of all invoices for this phase
                if(vm.project_invoices) {
                    vm.selectedNode.invoice_data = [];
                    vm.selectedNode.payment_data = [];
                    _.each(vm.project_invoices.invoices, function(invoice) {
                        if((vm.selectedNode.type === 'project') || 
                            (vm.selectedNode.phase == invoice.phase)) {
                            if(!invoice.code) {
                                var type = 'C';
                                if(invoice.type === 'option') {
                                    type = 'OP';
                                } else if (invoice.type === 'extra') {
                                    type = 'E';
                                }
                                invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                                '-' + aceUtils.padDigits(invoice.number, 2);
                            }
                            vm.selectedNode.invoice_data.push(invoice);

                            _.each(invoice.payments, function(payment) {
                                vm.selectedNode.payment_data.push({
                                    from: payment.from,
                                    reference: payment.reference,
                                    date: payment.date,
                                    type: invoice.type,
                                    code: invoice.code,
                                    amount: invoice.amount - invoice.paid, //amount is amount open after deducting amount paid
                                    paid: payment.amount,
                                });
                            });
                        }
                    });
                }

                if(vm.trade_draw_data && vm.trade_draw_data.length > 0) {
                    vm.drawDataSetup = true;
                } else {
                    vm.drawDataSetup = false;
                }
            }
        }
    };

    vm.builderSetup = function() {
        $location.state({
            'type': 'builder',
            'builder_name': vm.selectedNode.builder_name,
            'trade_code': vm.trade_code,
            'company_code': vm.user.contractor_code,
            'selection': vm.selectedNode
        });
        $location.url('/accounts/receivable/builder/setup');
    };

    vm.projectSetup = function() {
        userService.getMainAccountId(vm.user.username).then(function(id) {
            console.log('projectSetup setting state info');
            $location.state({
                'type': 'project',
                'builder_name': vm.selectedNode.builder_name,
                'job_code': vm.selectedNode.job_code,
                'trade_code': vm.trade_code,
                'company_code': vm.user.contractor_code,
                'selection': vm.selectedNode,
                'userId': id
            });
            $location.url('/accounts/receivable/project/setup');
        });
    };

    vm.addEstimate = function() {
        $location.state({
            'type': 'project',
            'builder_name': vm.selectedNode.builder_name,
            'job_code': vm.selectedNode.job_code,
            'trade_code': vm.trade_code,
            'company_code': vm.user.contractor_code
        });
        $location.url('/accounts/receivable/estimate/add');
    };

    vm.openEstimate = function(item) {
        if(vm.project) {
            ProjectTasks.query({'project_id': vm.project._id, 'trade_code': vm.trade_code, 'phase': item.phase}, function(tasks) {
                vm.current_open_estimate = item;
                if(item.details && item.type == 'contract') {
                    //we don't save contract totals so we need to grab them
                    _.each(item.details, function(detail) {
                        var lot = $filter('filter')(vm.project.lots, {'number': detail.lot, 'phase': item.phase}, true)[0];
                        var task = $filter('filter')(tasks, {'lot': detail.lot, 
                            'phase': item.phase, 'task_code': detail.task_code}, true)[0];
                        var plan_totals = $filter('filter')(vm.project.plan_codes, {'item': detail.plan}, true)[0];
                        if(plan_totals && typeof lot != 'undefined') {
                            var trade_total = $filter('filter')(plan_totals.trade_totals, {'trade': vm.user.trade[0]}, true);
                            if(trade_total) {
                                var rev = $filter('filter')(lot.revisions, {'trade': vm.user.trade[0]}, true)[0];
                                var rev_total = $filter('filter')(trade_total, {'revision': rev.revision}, true)[0];
                                detail.contract = (rev_total)?rev_total.total:0;
                            }
                        } else {
                            toaster.pop('error', 'Phase/Lot Error', item.phase + '/' + detail.lot + ' not found.  Regenerate estimate');
                        }
                        detail.status_finished = (task)? task.status == 'finished' : false;
                    })
                    vm.details = item.details;
                    vm.current_estimate_total = item.amount;
                } else if(item.details && item.type == 'option') {
                    _.each(item.details, function(detail) {
                        var lot = $filter('filter')(vm.project.lots, {
                            'number': detail.lot, 'phase': item.phase}, true)[0];
                        var option_number = detail.description.split(':');
                        var lot_op = $filter('filter')(lot.active_options, { 
                            'number': option_number[0] }, true)[0];
                        var task = $filter('filter')(tasks, {'lot': detail.lot, 
                            'phase': item.phase, 'task_code': detail.task_code}, true)[0];
                        var trade_op = null;
                        if(lot_op) {
                            trade_op = $filter('filter')(lot_op.totals, {
                                'trade': vm.user.trade[0] }, true)[0];
                        
                            detail.contract = (trade_op)?trade_op.total:0;
                        }
                        detail.status_finished = (task)? task.status == 'finished' : false;
                    });
                    vm.details = item.details;
                    vm.current_estimate_total = item.amount;
                } else if(item.details && item.type == 'extra') {
                    var phase_extras = $filter('filter')(vm.project_extras, {
                        'phase': item.phase }, true);

                    _.each(item.details, function(detail) {
                        var task = $filter('filter')(tasks, {'lot': detail.lot, 
                            'phase': item.phase, 'task_code': detail.task_code}, true)[0];
                        // var lot_extras = $filter('filter')(phase_extras, {
                        //     'lot': detail.lot }, true);
                        // var extra_total = 0;
                        // _.each(lot_extras, function(extra, idx) {
                        //     extra_total += extra.total;
                        // });
                        // detail.contract = extra_total;
                        detail.contract = detail.amount;
                        detail.status_finished = (task)? task.status == 'finished' : false;
                    });

                    vm.details = item.details;
                    vm.current_estimate_total = item.amount;
                } else {
                    vm.current_estimate_total = 0;
                    vm.details = [];
                    var project = $scope.getProjectEstimates(vm.selectedNode.job_code);
                    if(project) {
                        //filter based on phase and type of estimate
                        var phase = $filter('filter')(project.estimates, {
                            'phase': item.phase, 'type': item.type}, true)[0];
                        if(phase) {
                            _.each(phase.details, function(det) {
                                det.contract = det.amount;
                            });
                            vm.details = phase.details;
                            vm.current_estimate_total = phase.amount;
                        }
                    }
                }

                if(vm.selectedNode.type == 'phase') {
                    vm.pageState = 'viewEstimate';
                } else if(vm.selectedNode.type == 'project'){
                    console.log('need to navigate down on the left and update the view on the right.');
                    var select = $filter('filter')(vm.selectedNode.children, {'phase': item.phase}, true);
                    if(select.length == 1) {
                        $scope.invoiceDataRowSelected(select[0]);
                    }
                }
            });
        } 
    };

    vm.openInvoice = function(item) {
        item.invoice_date = moment(item.invoice_date).format('MMM D, YYYY');
        vm.current_open_invoice = item;
        vm.invoice_items = item.details;
        vm.invoice_code = item.code;
        vm.current_invoice_total = item.amount.toFixed(2);
        vm.invoice_type = item.type;
        vm.pageState = 'createInvoice';
    };

    vm.openPayment = function(item) {
        console.log(item);
        console.log(vm);
        vm.selectedNode.payment_data_by_reference = [];
        vm.selectedNode.payment_data_by_reference = 
            $filter('filter')(vm.selectedNode.payment_data, {'reference': item.reference}, true);
        vm.pageState = 'viewPayment';
    };

    vm.editAmount = function(item) {
        item.amountEditing = true;
    };

    vm.doneAmountEditing = function(item) {
        if(!item.amountEditing) return;
        var project_est = $scope.getProjectEstimates(vm.selectedNode.job_code);
        vm.selectedNode.estimate_total = 0;

        if(project_est.estimates.length === 0) {
            project_est.estimates = vm.details;
        } 

        //update totals
        _.each(project_est.estimates, function(estimate) {
            estimate.amount = 0;
            var current_estimate = false;
            _.each(estimate.details, function(detail) {
                if(item.lot === detail.lot &&
                    item.description === detail.description &&
                    item.task_code === detail.task_code) {
                    current_estimate = true;
                    estimate.amount += item.amount;
                    vm.selectedNode.estimate_total += item.amount;
                } else {
                    estimate.amount += detail.amount;
                    vm.selectedNode.estimate_total += detail.amount;
                }
            });

            if(current_estimate) {
                vm.current_estimate_total = estimate.amount;
            }
        });

        vm.updateEstimate(project_est);

        item.amountEditing = false;
    };

    vm.updateEstimateByJob = function(job_code) {
        var estimate = $scope.getProjectEstimates(job_code);
        estimate.$update(function(success) {
            toaster.pop('success', 'Estimate Updated');
            $scope.updateProjectEstimate(success);
        }, function(error) {
            toaster.pop('Error', 'Estimate Update Error', error);
        });
    };

    vm.updateEstimate = function(estimate) {
        estimate.$update(function(success) {
            toaster.pop('success', 'Estimate Updated');
            $scope.updateProjectEstimate(success);
        }, function(error) {
            toaster.pop('Error', 'Estimate Update Error', error);
        });
    };

    vm.saveEstimate = function(update) {
        console.log(vm);
        console.log(this);

        //get the project estimates from parent controller
        var project_est = $scope.getProjectEstimates(vm.selectedNode.job_code);

        if(project_est) {
            var node_est = $filter('filter')(project_est.estimates, {
                'phase': vm.selectedNode.phase, 
                'type': vm.current_open_estimate.type }, true)[0];

            if(node_est) {
                node_est.billed = vm.selectedNode.invoiced;
                node_est.paid = vm.selectedNode.paid;
                node_est.amount = vm.current_estimate_total;
                node_est.details = vm.details;
                node_est.date = new Date();
            } else {
                // var node_est = $filter('filter')(vm.selectedNode.estimates, {
                //     'phase': vm.selectedNode.phase, 
                //     'type': vm.current_open_estimate.type }, true)[0];
                project_est.estimates.push({
                    type: vm.current_open_estimate.type, //hard coded for now
                    phase: vm.selectedNode.phase,
                    number: vm.current_open_estimate.number,
                    date: new Date(),
                    amount: vm.current_estimate_total,
                    billed: vm.selectedNode.invoiced,
                    paid: vm.selectedNode.paid,
                    details: vm.details
                });
            }

            project_est.$update(function(success) {
                toaster.pop('success', 'Estimate Updated');
                var saved = $filter('filter')(success.estimates, {
                    'phase': vm.current_open_estimate.phase,
                    'type': vm.current_open_estimate.type }, true)[0];
                var view = $filter('filter')(vm.selectedNode.estimates, {
                    'phase': vm.current_open_estimate.phase,
                    'type': vm.current_open_estimate.type }, true)[0];

                view.amount = saved.amount;
                view.billed = saved.billed;
                view.date = saved.date;
                view.details = saved.details;
                view.paid = saved.paid;
                vm.selectedNode.estimate_data = vm.selectedNode.estimates
                
                console.log(vm);
                $rootScope.$emit("EstimateUpdated", success);
            }, function(error) {
                toaster.pop('Error', 'Estimate Update Error', error);
            });
        } else {
            var node_est = $filter('filter')(vm.selectedNode.estimates, {
                'phase': vm.selectedNode.phase}, true)[0];
            var estimate = new Estimates({
                trade_code: vm.trade_code,
                company_code: vm.user.contractor_code,
                job_code: vm.selectedNode.job_code,
                estimates: [{
                    type: vm.current_open_estimate.type, //hard coded for now
                    phase: vm.selectedNode.phase,
                    number: vm.current_open_estimate.number,
                    date: new Date(),
                    amount: vm.current_estimate_total,
                    billed: vm.selectedNode.invoiced,
                    paid: vm.selectedNode.paid,
                    details: vm.details
                }]
            });

            estimate.$save(function(success) {
                toaster.pop('success', 'Estimate Saved');
                var est = $filter('filter')(success.estimates, {
                    'number': vm.current_open_estimate.number}, true);
                if(est.length != 1) {
                    toaster.pop('error', 'Estimate Error', 'Reload the page');
                } else {
                    vm.current_open_estimate = est[0];
                }
                $rootScope.$emit("EstimateUpdated", success);
            }, function(error) {
                toaster.pop('Error', 'Estimate Save Error', error);
            });
        }
    };

    vm.deleteEstimate = function(page) {
        ngDialog.openConfirm({
            template: 
                '<h2>Delete Estimates Confirm</h2>' +
                '<p>This will remove the estimate from the database.</p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            console.log(vm);
            $scope.removeEstimate(vm.selectedNode, vm.current_open_estimate);

            vm.pageState = page;
        })
    };

    vm.deleteInvoice = function(page) {
        ngDialog.openConfirm({
            template: 
                '<h2>Delete Invoice Confirm</h2>' +
                '<p>This will remove the invoice from the database.</p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            console.log(vm);
            var project_inv = $scope.removeInvoice(vm.selectedNode, vm.current_open_invoice);
            var estimate = $filter('filter')(vm.selectedNode.estimates, {
                'type': vm.invoice_type, }, true)[0];
            if(!estimate) {
                toaster.pop('error', 'Estimate Error', 
                    'Problem getting estimate for this invoice');
                return;
            }
            
            _.each(vm.draw_selection, function(draw) {
                var est = $filter('filter')(estimate.details, { 'lot': draw.lot, 
                    'plan': draw.plan, 'task_code': draw.task_code }, true)[0];
                if(est) {
                    est.billed = draw.amount;
                }
            });

            estimate.billed = 0;
            _.each(estimate.details, function(detail) {
                estimate.billed += detail.billed;
            });

            vm.updateEstimateByJob(vm.selectedNode.job_code);
            vm.saveInvoice(true);
            estimate.trade_code = vm.trade_code;
            estimate.company_code = vm.user.contractor_code;
            estimate.job_code = vm.selectedNode.job_code;
            $rootScope.$emit("EstimateUpdated", estimate);
            vm.pageState = page;
        })
    };

    vm.changePageState = function(item) {
        vm.current_invoice_total = 0;
        if(item === 'createInvoice') {
            if(item.amount) {
                vm.current_invoice_total = item.amount.toFixed(2);
            } else {
                var amount = 0;
                _.each(vm.invoice_items, function(it) {
                    amount += it.amount;
                });
                vm.current_invoice_total = amount.toFixed(2);
            }
        } else if(item === 'receivePayment') {
            vm.payment.from = $filter('filter')(vm.items, {'label': vm.selectedNode.builder_name}, true)[0];
        }
        vm.pageState = item;
    };

    vm.createNewInvoice = function() {
        ngDialog.openConfirm({
            template: 'accounts-receivable/views/billing/invoice-type.html',
            data: {
                vm: vm
            },
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            //console.log(ngDialogData);
            console.log(vm, $scope.selected);
            vm.current_invoice_total = 0;
            vm.invoice_items = [];
            //vm.pageState = 'createInvoice';

            vm.addInvoiceItem();
            
        }, function (value) {
            //Do something
            //$scope.new_extra = false;
            vm.pageState = 'companyInfo';
            console.log('in the do something section');
        });
    };

    //pass in the project.lot and it will return the trade total for the revision
    vm.getLotContractTotal = function(lot) {
        if(lot.plan == 'T&M') return 0;

        var plan_totals = $filter('filter')(vm.project.plan_codes, {'item': lot.plan}, true)[0];
        if(plan_totals) {
            var trade_total = $filter('filter')(plan_totals.trade_totals, {'trade': vm.user.trade[0]}, true);
            if(trade_total) {
                var rev = $filter('filter')(lot.revisions, {'trade': vm.user.trade[0]}, true)[0];
                var rev_total = $filter('filter')(trade_total, {'revision': rev.revision}, true)[0];
                return rev_total.total
            }
        }
    };

    // vm.editInvoiceTotal = function() {
    //     vm.invoiceTotalEditing = true;
    // };

    // vm.doneInvoiceTotalEditing = function() {
    //     if(!vm.invoiceTotalEditing) return;
    //     vm.current_open_invoice.amount = 
    //         vm.current_invoice_total;

    //     vm.saveInvoice();
    //     vm.invoiceTotalEditing = false;
    // };

    vm.editInvoiceAmount = function(item) {
        item.invoiceAmountEditing = true;
    };

    vm.doneInvoiceAmountEditing = function(invoice_items, item) {
        if(!item.invoiceAmountEditing) return;
        var total = 0;

        _.each(vm.current_open_invoice.details , function(lineItem) {
            total = total + parseFloat(lineItem.amount);
        });

        var proj_estimates = $scope.getProjectEstimates(vm.selectedNode.job_code);

        var estimate = $filter('filter')(proj_estimates.estimates, {
            'type': vm.invoice_type, 'phase': vm.selectedNode.phase }, true)[0];
        if(!estimate) {
            toaster.pop('error', 'Estimate Error', 
                'Need to create an estimate before the invoice can be created.');
            return;
        }
        
        _.each(estimate.details, function(draw) {
            var est = $filter('filter')(estimate.details, { 'lot': item.lot, 
                'plan': item.plan, 'task_code': item.task_code }, true)[0];
            if(est) {
                est.billed = item.amount;
                est.amount = item.amount;
            }
        });

        estimate.billed = 0;
        estimate.amount = 0;
        _.each(estimate.details, function(detail) {
            detail.billed = parseFloat(detail.billed);
            detail.amount = parseFloat(detail.amount);
            estimate.billed += detail.billed;
            estimate.amount += detail.amount;
        });

        vm.updateEstimate(proj_estimates);

        vm.current_open_invoice.amount = total;
        vm.current_open_invoice.invoice_date = 
            new Date(vm.current_open_invoice.invoice_date);

        vm.saveInvoice();
        estimate.trade_code = vm.trade_code;
        estimate.company_code = vm.user.contractor_code;
        estimate.job_code = vm.selectedNode.job_code;
        $rootScope.$emit("EstimateUpdated", estimate);
        item.invoiceAmountEditing = false;
    };

    vm.saveInvoiceSingle = function(isDelete, isPayment) {
        var idx = -1;
        var inv_idx = -1

        _.each(vm.project_invoices.invoices, function(invoice, jj) {
            if(vm.current_open_invoice._id === invoice._id) {
                vm.current_open_invoice = vm.project_invoices.invoices[jj];
            }
        });

        //if(idx != -1 && inv_idx != -1) {
            //vm.current_open_invoice = vm.project_invoices[idx].invoices[inv_idx];
            vm.project_invoices.$update(function(success) {
                if(isPayment) {
                    toaster.pop('success', 'Payment Saved');
                } else {
                    toaster.pop('success', 'Invoice Saved');
                }

                vm.project_invoices = success;

                var current_invoice = $filter('filter')(success.invoices, {
                    '_id': vm.current_open_invoice._id }, true);

                if(isDelete) {

                } else {
                    if(current_invoice.length != 1) {
                        toaster.pop('error', 'Problem finding invoice', 
                            'Refresh the view to see updated fields.')
                    } else {
                        vm.current_open_invoice = current_invoice[0];
                        vm.current_open_invoice.invoice_date = 
                            moment(current_invoice[0].invoice_date).format('MMM D, YYYY');
                        vm.current_invoice_total = current_invoice[0].amount.toFixed(2);
                    }
                }

                vm.selectedNode.invoice_data = [];
                vm.selectedNode.payment_data = [];
                _.each(vm.project_invoices.invoices, function(invoice) {
                    if(vm.selectedNode.phase == invoice.phase) {
                        if(!invoice.code) {
                            var type = 'C';
                            if(invoice.type === 'option') {
                                type = 'OP';
                            } else if (invoice.type === 'extra') {
                                type = 'E';
                            }
                            invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                            '-' + aceUtils.padDigits(invoice.number, 2);
                        }
                        vm.selectedNode.invoice_data.push(invoice);
                    }
     
                    _.each(invoice.payments, function(payment) {
                        vm.selectedNode.payment_data.push({
                            amount: invoice.amount - invoice.paid,
                            code: invoice.code,
                            date: payment.date,
                            from: payment.from,
                            paid: payment.amount,
                            reference: payment.reference,
                            type: invoice.type
                        })
                    });
                });

                $rootScope.$emit("InvoiceUpdated", success);
                $scope.getAllCustomers($scope.mainAccountID);
                vm.payment = { amount: 0, from: '', date: null, reference: ''}
            }, function(error) {
                toaster.pop('Error', 'Invoice Save Error', error);
            });
        //}
    };

    vm.saveInvoiceMultiple = function(isDelete, isPayment) {
        var idx = -1;
        var inv_idx = -1

        _.each(vm.project_invoices, function(proj_invoice, ii) {
            _.each(proj_invoice.invoices, function(invoice, jj) {
                if(invoice.select === true) {
                    idx = ii;
                    inv_idx = jj;
                }
            })
        })

        if(idx != -1 && inv_idx != -1) {
            vm.current_open_invoice = vm.project_invoices[idx].invoices[inv_idx];
            vm.project_invoices[idx].$update(function(success) {
                if(isPayment) {
                    toaster.pop('success', 'Payment Saved');
                } else {
                    toaster.pop('success', 'Invoice Saved');
                }

                vm.project_invoices[idx] = success

                var current_invoice = $filter('filter')(success.invoices, {
                    '_id': vm.current_open_invoice._id }, true);

                if(isDelete) {

                } else {
                    if(current_invoice.length != 1) {
                        toaster.pop('error', 'Problem finding invoice', 
                            'Refresh the view to see updated fields.')
                    } else {
                        vm.current_open_invoice = current_invoice[0];
                        vm.current_open_invoice.invoice_date = 
                            moment(current_invoice[0].invoice_date).format('MMM D, YYYY');
                        vm.current_invoice_total = current_invoice[0].amount.toFixed(2);
                    }
                }

                vm.selectedNode.invoice_data = [];
                vm.selectedNode.payment_data = [];
                _.each(vm.project_invoices.invoices, function(invoice) {
                    if(vm.selectedNode.phase == invoice.phase) {
                        if(!invoice.code) {
                            var type = 'C';
                            if(invoice.type === 'option') {
                                type = 'OP';
                            } else if (invoice.type === 'extra') {
                                type = 'E';
                            }
                            invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                            '-' + aceUtils.padDigits(invoice.number, 2);
                        }
                        vm.selectedNode.invoice_data.push(invoice);
                    }
     
                    _.each(invoice.payments, function(payment) {
                        vm.selectedNode.payment_data.push({
                            amount: invoice.amount - invoice.paid,
                            code: invoice.code,
                            date: payment.date,
                            from: payment.from,
                            paid: payment.amount,
                            reference: payment.reference,
                            type: invoice.type
                        })
                    });
                });

                $rootScope.$emit("InvoiceUpdated", success);
                $scope.getAllCustomers($scope.mainAccountID);
                vm.payment = { amount: 0, from: '', date: null, reference: ''}
            }, function(error) {
                toaster.pop('Error', 'Invoice Save Error', error);
            });
        }
    };

    vm.saveInvoice = function(isDelete, isPayment) {
        if(angular.isArray(vm.project_invoices)) {
            vm.saveInvoiceMultiple(isDelete, isPayment);
        } else {
            vm.saveInvoiceSingle(isDelete, isPayment);
        }
    };

    vm.saveInvoiceAllSingle = function(isDelete, isPayment) {
        //var idx = 0;
        //var inv_idx = 0;

        //_.each(vm.project_invoices, function(proj_invoice, ii) {
            var do_update = false;
            _.each(vm.project_invoices.invoices, function(invoice, jj) {
                if(invoice.select === true) {
                    //idx = ii;
                    //inv_idx = jj;
                    do_update = true;
                    //vm.current_open_invoice = vm.project_invoices[idx].invoices[inv_idx];
                    vm.project_invoices.invoices[jj] = vm.project_invoices.invoices[jj];
                }
            })

            if(do_update) {
                vm.project_invoices.$update(function(success) {
                    if(isPayment) {
                        toaster.pop('success', 'Payment Saved');
                    } else {
                        toaster.pop('success', 'Invoice Saved');
                    }

                    vm.project_invoices = success

                    // var current_invoice = $filter('filter')(success.invoices, {
                    //     '_id': vm.current_open_invoice._id }, true);

                    // if(isDelete) {

                    // } else {
                    //     if(current_invoice.length == 1) {
                    //         vm.current_open_invoice = current_invoice[0];
                    //         vm.current_open_invoice.invoice_date = 
                    //             moment(current_invoice[0].invoice_date).format('MMM D, YYYY');
                    //         vm.current_invoice_total = current_invoice[0].amount.toFixed(2);
                    //     }
                    // }

                    vm.selectedNode.invoice_data = [];
                    vm.selectedNode.payment_data = [];
                    _.each(vm.project_invoices.invoices, function(invoice) {
                        if(vm.selectedNode.phase == invoice.phase) {
                            if(!invoice.code) {
                                var type = 'C';
                                if(invoice.type === 'option') {
                                    type = 'OP';
                                } else if (invoice.type === 'extra') {
                                    type = 'E';
                                }
                                invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                                '-' + aceUtils.padDigits(invoice.number, 2);
                            }
                            vm.selectedNode.invoice_data.push(invoice);
                        }
         
                        _.each(invoice.payments, function(payment) {
                            vm.selectedNode.payment_data.push({
                                amount: invoice.amount - invoice.paid,
                                code: invoice.code,
                                date: payment.date,
                                from: payment.from,
                                paid: payment.amount,
                                reference: payment.reference,
                                type: invoice.type
                            })
                        });
                    });

                    // $rootScope.$emit("InvoiceUpdated", success);
                    // $scope.getAllCustomers($scope.mainAccountID);
                    // vm.payment = { amount: 0, from: '', date: null, reference: ''}
                }, function(error) {
                    toaster.pop('Error', 'Invoice Save Error', error);
                });
            }
        //})

        //$rootScope.$emit("InvoiceUpdated", success);
        $scope.getAllCustomers($scope.mainAccountID);
        vm.payment = { amount: 0, from: '', date: null, reference: ''}
    };

    vm.saveInvoiceAllMultiple = function(isDelete, isPayment) {
        //var idx = 0;
        //var inv_idx = 0;

        _.each(vm.project_invoices, function(proj_invoice, ii) {
            var do_update = false;
            _.each(proj_invoice.invoices, function(invoice, jj) {
                if(invoice.select === true) {
                    //idx = ii;
                    //inv_idx = jj;
                    do_update = true;
                    //vm.current_open_invoice = vm.project_invoices[idx].invoices[inv_idx];
                    vm.project_invoices[ii].invoices[jj] = vm.project_invoices[ii].invoices[jj];
                }
            })

            if(do_update) {
                vm.project_invoices[ii].$update(function(success) {
                    if(isPayment) {
                        toaster.pop('success', 'Payment Saved');
                    } else {
                        toaster.pop('success', 'Invoice Saved');
                    }

                    vm.project_invoices[ii] = success

                    // var current_invoice = $filter('filter')(success.invoices, {
                    //     '_id': vm.current_open_invoice._id }, true);

                    // if(isDelete) {

                    // } else {
                    //     if(current_invoice.length == 1) {
                    //         vm.current_open_invoice = current_invoice[0];
                    //         vm.current_open_invoice.invoice_date = 
                    //             moment(current_invoice[0].invoice_date).format('MMM D, YYYY');
                    //         vm.current_invoice_total = current_invoice[0].amount.toFixed(2);
                    //     }
                    // }

                    vm.selectedNode.invoice_data = [];
                    vm.selectedNode.payment_data = [];
                    _.each(vm.project_invoices[ii].invoices, function(invoice) {
                        if(vm.selectedNode.phase == invoice.phase) {
                            if(!invoice.code) {
                                var type = 'C';
                                if(invoice.type === 'option') {
                                    type = 'OP';
                                } else if (invoice.type === 'extra') {
                                    type = 'E';
                                }
                                invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                                '-' + aceUtils.padDigits(invoice.number, 2);
                            }
                            vm.selectedNode.invoice_data.push(invoice);
                        }
         
                        _.each(invoice.payments, function(payment) {
                            vm.selectedNode.payment_data.push({
                                amount: invoice.amount - invoice.paid,
                                code: invoice.code,
                                date: payment.date,
                                from: payment.from,
                                paid: payment.amount,
                                reference: payment.reference,
                                type: invoice.type
                            })
                        });
                    });

                    // $rootScope.$emit("InvoiceUpdated", success);
                    // $scope.getAllCustomers($scope.mainAccountID);
                    // vm.payment = { amount: 0, from: '', date: null, reference: ''}
                }, function(error) {
                    toaster.pop('Error', 'Invoice Save Error', error);
                });
            }
        })

        //$rootScope.$emit("InvoiceUpdated", success);
        $scope.getAllCustomers($scope.mainAccountID);
        vm.payment = { amount: 0, from: '', date: null, reference: ''}
    };

    vm.saveInvoiceAll = function(isDelete, isPayment) {
        if(angular.isArray(vm.project_invoices)) {
            vm.saveInvoiceAllMultiple(isDelete, isPayment);
        } else {
            vm.saveInvoiceAllSingle(isDelete, isPayment);
        }
    };

    vm.doneInvoiceDateEditing = function(newValue, oldValue) {
        vm.current_open_invoice.invoice_date = 
            new Date(vm.current_open_invoice.invoice_date);

        vm.saveInvoice();
    }

    vm.getTypeCode = function(type) {
        var retVal = 'C';

        if(type === 'option') {
            retVal = 'OP';
        } else if (type === 'extra') {
            retVal = 'E';
        }

        return retVal;
    };

    vm.numbers = [];

    for(var i=1; i<100; i++) {
        vm.numbers.push(("000000"+i).slice(-2));
    };

    vm.doneInvoiceNumberEditing = function(item) {
        if(!this.invoiceNumberEditing) return;
        // vm.current_open_invoice.number = vm.invoice_code_number;
        // var array = vm.invoice_code.split('-');
        // array[3] = vm.invoice_code_number;

        // vm.invoice_code = array[0] + '-' + array[1] +
        //     '-' + array[2] + '-' + array[3];
        vm.current_open_invoice.invoice_date = 
            new Date(vm.current_open_invoice.invoice_date);

        vm.saveInvoice();
        this.invoiceNumberEditing = false;
    };

    vm.addInvoiceItem = function() {
        var project = $scope.getProjectEstimates(vm.selectedNode.job_code);
        if(project) {
            var phase = $filter('filter')(project.estimates, {
                'phase': vm.selectedNode.phase,
                'type': vm.invoice_type }, true)[0];
            if(phase) {
                vm.details = phase.details;
                //vm.current_estimate_total = phase.amount;
            } else {
                vm.details = []; 
            }
        }
        vm.invoice_code = '';
        vm.inputText = vm.selectedNode.builder_name

        ngDialog.openConfirm({
            template: 'accounts-receivable/views/billing/add-invoice-item.html',
            scope: $scope,
            data: {
                vm: vm
            },
            className: 'ngdialog-theme-default'
        }).then(function (value) {

            if(!vm.inputText) {
                toaster.pop('error', 'Error', 'Enter customer name.');
                return;
            }
            console.log(vm, $scope.selected);
            vm.pageState = 'createInvoice';

            if(!vm.invoices) {
                vm.invoice_items = [];
                vm.current_invoice_total = 0;
            }

            vm.project_invoices = $scope.getProjectInvoices(vm.selectedNode.job_code);
            var proj_estimates = $scope.getProjectEstimates(vm.selectedNode.job_code);
            var estimate = $filter('filter')(proj_estimates.estimates, {
                'type': vm.invoice_type, 'phase': vm.selectedNode.phase }, true)[0];
            if(!estimate) {
                toaster.pop('error', 'Estimate Error', 
                    'Need to create an estimate before the invoice can be created.');
                return;
            }

            if(!estimate.details) {
                toaster.pop('error', 'Estimate Details Error', 
                    'Could not get the estimate details. Please reload the page and try again.');
                return;
            }
            var amount = 0;
            _.each(vm.draw_selection, function(draw) {
                var lot = $filter('filter')(vm.project.lots, {
                    'number': draw.lot, 'phase': vm.selectedNode.phase}, true)[0];

                if(lot) {
                    var amt = vm.getLotContractTotal(lot);
                    if(amt) {
                        draw.contract = amt;
                    } else {
                        draw.contract = draw.amount;
                    }
                } else 
                    draw.contract = 0;

                var est = $filter('filter')(estimate.details, { 'lot': draw.lot, 
                    'plan': draw.plan, 'task_code': draw.task_code }, true)[0];
                if(est) {
                    est.billed = draw.amount;
                }
                
                amount += draw.amount;
            });

            estimate.billed = 0;
            _.each(estimate.details, function(detail) {
                estimate.billed += detail.billed;
            });

            vm.updateEstimateByJob(vm.selectedNode.job_code);

            vm.current_invoice_total = amount.toFixed(2);

            if(vm.project_invoices) {
                var invoices = $filter('filter')(vm.project_invoices.invoices, {
                    'type': vm.invoice_type }, true);

                var num = invoices.length;
                for(var i=0; i<invoices.length; i++) {
                    if(invoices[i].number == num) {
                        num += 1;
                    }
                }

                var inv = {
                    type: vm.invoice_type,
                    details: vm.draw_selection,
                    amount: amount,
                    paid: 0,
                    phase: vm.selectedNode.phase,
                    number: (num==0)?1:num,
                    customer_name : vm.inputText,
                    start_date: new Date(),
                    complete_date: new Date(),
                    invoice_date: new Date(),
                    payments: []
                }
                var saved_code = inv.code = vm.selectedNode.job_code + '-' + 
                    inv.phase + '-' + vm.getTypeCode(inv.type) +
                    '-' + aceUtils.padDigits(inv.number, 2);

                //add invoice for this project
                vm.project_invoices.invoices.push(inv);
console.log('Calling project_invoices update function');
                vm.project_invoices.$update(function(success) {
                    toaster.pop('success', 'Invoice Saved');
                    vm.project_invoices = success

                    var current_invoice = $filter('filter')(success.invoices, {
                        'code': saved_code }, true);

                    if(current_invoice.length != 1) {
                        toaster.pop('error', 'Problem finding invoice', 
                            'Refresh the view to see updated fields.')
                    } else {
                        vm.current_open_invoice = current_invoice[0];
                        vm.current_open_invoice.invoice_date = 
                            moment(current_invoice[0].invoice_date).format('MMM D, YYYY');
                        vm.current_invoice_total = current_invoice[0].amount.toFixed(2);
                    }

                    vm.selectedNode.invoice_data = [];
                    vm.selectedNode.payment_data = [];
                    _.each(vm.project_invoices.invoices, function(invoice) {
                        if(vm.selectedNode.phase == invoice.phase) {
                            if(!invoice.code) {
                                var type = 'C';
                                if(invoice.type === 'option') {
                                    type = 'OP';
                                } else if (invoice.type === 'extra') {
                                    type = 'E';
                                }
                                invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                                '-' + aceUtils.padDigits(invoice.number, 2);
                            }
                            vm.selectedNode.invoice_data.push(invoice);
                        }
         
                        _.each(invoice.payments, function(payment) {
                            vm.selectedNode.payment_data.push({
                                amount: invoice.amount - invoice.paid,
                                code: invoice.code,
                                date: payment.date,
                                from: payment.from,
                                paid: payment.amount,
                                reference: payment.reference,
                                type: invoice.type
                            })
                        });
                    });
console.log('CALLING THE EMIT FUNCTION AFTER UPDATE');
                    //$scope.updateProjectEstimate(vm.current_open_estimate);
                    //vm.updateEstimateByJob(vm.selectedNode.job_code);
                    estimate.trade_code = vm.trade_code;
                    estimate.company_code = vm.user.contractor_code;
                    estimate.job_code = vm.selectedNode.job_code;
                    $rootScope.$emit("EstimateUpdated", estimate);
                    $rootScope.$emit("InvoiceUpdated", success);
                    $scope.getAllCustomers($scope.mainAccountID);
                    vm.payment = { amount: 0, from: '', date: null, reference: ''}
                }, function(error) {
                    toaster.pop('Error', 'Invoice Save Error', error);
                });
            } else {
                //no invoice for this project so create a new one
                var inv = new TradeInvoices({
                    trade_code: vm.trade_code,
                    company_code: vm.user.contractor_code,
                    job_code: vm.selectedNode.job_code,
                    project_id: vm.selectedNode.project_id,
                    project_name: vm.selectedNode.project_name,
                    project_phase: vm.selectedNode.phase,
                    customer_name: vm.inputText,
                    userId : $scope.mainAccountID,
                    invoice_type: vm.invoice_type,
                    invoices: [{
                        'type': vm.invoice_type,
                        'number': 1,
                        'customer_name': vm.inputText,
                        'start_date': new Date(),
                        'complete_date': new Date(),
                        'invoice_date': new Date(),
                        'phase': vm.selectedNode.phase,
                        'amount': amount,
                        'paid': 0,
                        'details': vm.draw_selection
                    }]
                });

                inv.code = vm.selectedNode.job_code + '-' + 
                    vm.selectedNode.phase + '-' + vm.getTypeCode(vm.invoice_type) +
                    '-' + aceUtils.padDigits(1, 2);

                inv.$save(function(success) {
                    toaster.pop('success', 'Invoice Saved');
                    vm.project_invoices = success;

                    vm.newInvoiceTransaction(success);
                    $scope.getAllCustomers($scope.mainAccountID);

                    console.log('saved success', success);
                    console.log('vm.project_invoices', vm.project_invoices);
                    console.log('vm.selectedNode', vm.selectedNode);

                    vm.selectedNode.invoice_data = [];
                    _.each(vm.project_invoices.invoices, function(invoice) {
                        if(vm.selectedNode.phase == invoice.phase) {
                            if(!invoice.code) {
                                var type = 'C';
                                if(invoice.type === 'option') {
                                    type = 'OP';
                                } else if (invoice.type === 'extra') {
                                    type = 'E';
                                }
                                invoice.code = vm.selectedNode.job_code + '-' + invoice.phase + '-' + type +
                                    '-' + aceUtils.padDigits(invoice.number, 2);
                            }
                            vm.selectedNode.invoice_data.push(invoice);
                        }
                    });

                    vm.current_open_invoice = success;
                    
                    vm.updateEstimateByJob(vm.selectedNode.job_code);

                    estimate.trade_code = vm.trade_code;
                    estimate.company_code = vm.user.contractor_code;
                    estimate.job_code = vm.selectedNode.job_code;
                    $rootScope.$emit("EstimateUpdated", estimate);
                    $rootScope.$emit("InvoiceUpdated", success);
                }, function(error) {
                    toaster.pop('Error', 'Invoice Save Error', error);
                });
            }

            vm.invoice_items = vm.draw_selection;
        }, function (value) {
            //Do something
            //$scope.new_extra = false;
            vm.pageState = 'companyInfo';
            console.log('in the do something section');
        });
    };

    vm.newInvoiceTransaction = function (data) {
        
    };

    vm.generateEstimates = function() {
        ngDialog.openConfirm({
            template: 
                '<h2>Generate Estimates Confirm</h2>' +
                '<p>This will generate the estimate details for this phase and will refresh the data.</p>' +
                '<p>Any manually generated estimate items will need to be reentered. </p>' +
                '<p>Are you sure you wish to continue? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;</button>' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            scope: $scope,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            console.log(vm);

            var line_items = [];
            var total = 0;
            var lots = $filter('filter')(vm.project.lots, {'phase': vm.selectedNode.phase}, true);

            if(vm.current_open_estimate.type === 'contract') {
                if(vm.draw_items.length === 0) {
                    vm.draw_items = $filter('unique')(vm.trade_draw_data, 'number');
                }

                _.each(vm.draw_items, function(draw) {
                    _.each(lots, function(lot) {
                        if(lot.plan != 'T&M') {
                            var plan_totals = $filter('filter')(vm.project.plan_codes, {'item': lot.plan}, true)[0];
                            if(plan_totals) {
                                var trade_total = $filter('filter')(plan_totals.trade_totals, {'trade': vm.user.trade[0]}, true);
                                if(trade_total) {
                                    var rev = $filter('filter')(lot.revisions, {'trade': vm.user.trade[0]}, true)[0];
                                    var rev_total = $filter('filter')(trade_total, {'revision': rev.revision}, true)[0];
                                    var my_draw = $filter('filter')(vm.trade_draw_data, {
                                        'number': draw.number, 'plan': lot.plan }, true);
                                    if(my_draw.length !== 1) {
                                        console.log('got a problem');
                                    }
                                    total += my_draw[0].draw;
                                    line_items.push({
                                        'description': 'Draw ' + draw.number + ': ' + draw.name,
                                        'lot': lot.number,
                                        'plan': lot.plan,
                                        'task_code': draw.task_code,
                                        'contract': rev_total.total,
                                        //'contract': my_draw[0].draw,
                                        'is_rate': (draw.v_or_p === 'P')?true:false,
                                        'rate': (draw.v_or_p === 'P')?draw.value:0,
                                        'amount': my_draw[0].draw,
                                        'completed': false,
                                        'billed': 0,
                                        'paid': 0,
                                    });
                                }
                            }
                        }
                    });
                });
            } else if(vm.current_open_estimate.type === 'option') {
                console.log('option stuff');
                _.each(vm.trade_options, function(trade_option) {
                    _.each(lots, function(lot) {
                        if(lot.plan != 'T&M') {
                            var lot_op = $filter('filter')(lot.active_options, { 
                                'number': trade_option.option_number }, true)[0];
                            var trade_op = null;
                            if(lot_op) {
                                trade_op = $filter('filter')(lot_op.totals, {
                                    'trade': vm.user.trade[0] }, true)[0];
                            
                                if(trade_op) {
                                    total += (trade_op)?trade_op.total:0;
                                    line_items.push({
                                        'description': trade_option.option_number + 
                                            ': ' + trade_option.option_name,
                                        'lot': lot.number,
                                        'plan': lot.plan,
                                        //'task_code': draw.task_code,
                                        'contract': trade_op.total,
                                        'amount': trade_op.total,
                                        'completed': false,
                                        'billed': 0,
                                        'paid': 0,
                                    });
                                }
                            }
                        }
                    });
                });
            } else if(vm.current_open_estimate.type === 'extra') {
                console.log('extra stuff');
                if(vm.project_settings.merge_awa_selection) {
                    //combine extras with the same AWA in to one line for this phase
                    var phase_extras = $filter('filter')(vm.project_extras, {
                        'phase': vm.currentlySelectedNode.phase }, true);
                    _.each(phase_extras, function(extra) {
                        var inlist = $filter('filter')(line_items, {
                            'awa_number': extra.awa_number }, true);

                        //get the plan from the lots info
                        var lot = $filter('filter')(lots, {'number': extra.lot,
                            'phase': extra.phase }, true)[0];

                        if(inlist.length > 0) {
                            //combine here
                            inlist[0].lot = 'Mult';
                            inlist[0].plan = 'Mult';
                            inlist[0].contract += extra.total;
                            inlist[0].amount += extra.total;
                        } else {
                            //new entry
                            line_items.push({
                                'awa_number': extra.awa_number,
                                'description': 'AWA: ' + 
                                    aceUtils.padDigits(extra.awa_number, 6) +
                                    ' FPO: ' + extra.fpo,
                                'lot': extra.lot,
                                'plan': lot.plan,
                                'task_code': extra.task,
                                'contract': extra.total,
                                'amount': extra.total,
                                'completed': false,
                                'billed': 0,
                                'paid': 0,
                            });
                        }

                        total += extra.total;
                    })
                } else {
                    //per lot extras listed. 
                    var phase_extras = $filter('filter')(vm.project_extras, {
                        'phase': vm.currentlySelectedNode.phase }, true);

                    //var extra_total = 0;
                    _.each(phase_extras, function(extra) {
                        var project_lot = $filter('filter')(lots, {
                            'number': extra.lot, 'phase': extra.phase}, true)[0];
                        var desc = 'AWA: ' + aceUtils.padDigits(extra.awa_number, 6) + 
                            ' FPO: ' + extra.fpo;
                        line_items.push({
                            'awa_number': extra.awa_number,
                            'description': desc,
                            'lot': extra.lot,
                            'plan': project_lot?project_lot.plan:'NA',
                            'task_code': extra.task,
                            'contract': extra.total,
                            'amount': extra.total,
                            'completed': false,
                            'billed': 0,
                            'paid': 0,
                        });

                        total += extra.total;
                    });

                    // _.each(lots, function(lot) {
                    //     var lot_extras = $filter('filter')(phase_extras, {
                    //         'lot': lot.number }, true);

                    //     var extra_total = 0;

                    //     if(lot_extras.length != 0) {
                    //         var awa_number = lot_extras[0].awa_number;
                    //         var fpo = lot_extras[0].fpo;
                    //         var awa_multiple = false;
                    //         var numbers = [];
                    //         _.each(lot_extras, function(extra, idx) {
                    //             extra_total += extra.total;

                    //             if(numbers.indexOf(extra.awa_number) === -1) {
                    //                 numbers.push(extra.awa_number);
                    //             }
                    //         });

                    //         var desc = (awa_multiple)?'Mult': 'AWA: ' + 
                    //             aceUtils.padDigits(awa_number, 6) + ' FPO: ' + fpo;
                    //         line_items.push({
                    //             'awa_number': (numbers.length>1)?'Mult':awa_number,
                    //             'description': (numbers.length>1)?'Mult':desc,
                    //             'lot': lot.number,
                    //             'plan': lot.plan,
                    //             //'task_code': extra.task,
                    //             'contract': extra_total,
                    //             'amount': extra_total,
                    //             'completed': false,
                    //             'billed': 0,
                    //             'paid': 0,
                    //         });
                    //     } 

                    //     total += extra_total;
                    // });
                }
            }

            vm.current_open_estimate.details = vm.details = line_items;
            vm.current_open_estimate.date = new Date();
            vm.current_estimate_total = total;
            //$scope.updateProjectEstimate(vm.current_open_estimate);
            vm.saveEstimate();
        }, function (value) {
            //Do something 
            console.log('in the do something section');
        });
    };

    vm.savePayment = function() {
        console.log(vm);
        //check that allotted amounts match up.
        var total = 0;
        _.each(vm.selectedNode.invoice_data, function(invoice) {
            if(invoice.select) {
                total += invoice.payment_amount;
            }
        });

        total = Math.round(total * 100) / 100;

        if(total != vm.payment.amount) {
            toaster.pop('error', 'Payment Amount Error', 'Payment Amounts need to add up to total Amount');
            return;
        }

        if(!vm.payment.from) {
            toaster.pop('error', 'Customer Name Error', 'Enter Customer name.');
            return;
        }

        if(!vm.payment.depositAc) {
            toaster.pop('error', 'Deposit Account Error', 'Select Deposit Account Name.');
            return;
        }

        if(!vm.payment.date) {
            toaster.pop('error', 'Payment Date Error', 'Select Payment date.');
            return;
        }

        if(!vm.payment.reference) {
            toaster.pop('error', 'Payment Reference Error', 'Enter Payment reference.');
            return;
        }

        

        _.each(vm.selectedNode.invoice_data, function(invoice) {
            if(invoice.select) {
                var payment = {
                    amount: invoice.payment_amount,
                    from: vm.payment.from.label,
                    date: vm.payment.date,
                    depositId: vm.payment.depositAc._id,
                    depositACName: vm.payment.depositAc.name,
                    reference: vm.payment.reference
                }
                invoice.payments.push(payment);
                var curr_amount = angular.copy(invoice.payment_amount);
                _.each(invoice.details, function(detail) {
                    if(!detail.paid) detail.paid = 0;
                    var amt = detail.amount - detail.paid;
                    if((curr_amount != 0) && (amt > 0)) {
                        if(amt <= curr_amount) {
                            detail.paid += amt;
                            curr_amount -= amt;
                        } else if(amt > curr_amount) {
                            detail.paid += curr_amount;
                            curr_amount = 0;
                        }

                        if(detail.amount - detail.paid < 0.01) {
                            detail.completed = true;
                        }
                    }
                });
            }

            var total_paid = 0;
            _.each(invoice.payments, function(payment) {
                total_paid += payment.amount;
            });
            invoice.paid = total_paid;

            if(invoice.paid - invoice.amount < 0.01) {
                if(invoice.paid_date)
                    invoice.paid_date = new Date(invoice.paid_date);
                else
                    invoice.paid_date = new Date();
            }
        });

        vm.saveInvoiceAll(false, true);
    };

    vm.changePaymentAmount = function(item) {
        console.log('vm', vm);
        if(item.select) {
            item.payment_amount = item.amount - item.paid;
        } else {
            item.payment_amount = 0;
        }

        // update amount to the data
        var total = 0;
        _.each(vm.selectedNode.invoice_data, function(invoice) {
            if(invoice.select) {
                total += invoice.payment_amount;
            }
        });
        vm['payment']['amount'] = Math.round(total * 100) / 100;
    };

    vm.totalPayment = function() {
        // update amount to the data
        var total = 0;
        _.each(vm.selectedNode.invoice_data, function(invoice) {
            if(invoice.select) {
                total += invoice.payment_amount;
            }
        });
        vm['payment']['amount'] = Math.round(total * 100) / 100;
    };

    vm.getBilledAmount = function(item) {
        var amount = 0;
        for(var i=0; i<vm.selectedNode.invoice_data.length; i++) {
            if(vm.selectedNode.invoice_data[i].phase == item.phase &&
                vm.selectedNode.invoice_data[i].type == item.type) {
                amount += vm.selectedNode.invoice_data[i].amount;
            }
        }
        return amount;
    };

    vm.getPaidAmount = function(item) {
        var paid = 0;
        for(var i=0; i<vm.selectedNode.invoice_data.length; i++) {
            if(vm.selectedNode.invoice_data[i].phase == item.phase &&
                vm.selectedNode.invoice_data[i].type == item.type) {
                paid += vm.selectedNode.invoice_data[i].paid;
            }
        }
        return paid;
    };

    vm.getEstimatePaidAmount = function(item) {
        for(var i=0; i<vm.selectedNode.invoice_data.length; i++) {
            var invoice = vm.selectedNode.invoice_data[i];
            for(var j=0; j<invoice.details.length; j++) {
                if(invoice.details[j].description == item.description &&
                    invoice.details[j].lot == item.lot &&
                    invoice.details[j].task_code == item.task_code) {
                    return invoice.details[j].paid;
                }
            }
        }
        return 0;
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/controllers/billingInvoice.js